module.exports = __webpack_public_path__ + "static/media/relaytera.d02b4c3b.png";